import { useGeoContext } from '../contexts/GeoProvider';

export const SYMBOL_MAP = {
  EUR: '€',
  USD: '$',
};

function format(x: any) {
  if (x % 1 > 0) {
    return parseFloat(x).toFixed(2);
  }
  return x;
}

export function symbolForCurrencyCode(currencyCode: keyof typeof SYMBOL_MAP) {
  return SYMBOL_MAP[currencyCode] || '';
}

export function formatPriceShort(
  currencyCode: keyof typeof SYMBOL_MAP,
  price: any,
) {
  const currencySymbol = SYMBOL_MAP[currencyCode] || '';
  return `${currencySymbol}${format(price)}`;
}

export default function useCurrency() {
  const { countryData } = useGeoContext();
  const currencyCode = countryData?.currency as keyof typeof SYMBOL_MAP;
  const currencySymbol = SYMBOL_MAP[currencyCode];

  return {
    countryData,
    currencyCode,
    currencySymbol,
  };
}
